/* eslint-disable no-unused-vars */
import { createStore } from "vuex";
import axios from "axios";
import * as Cookies from "js-cookie";
import router from "@/router";

export default createStore({
  state: {
    baseurl: "https://tusemapi.tusdata.com/api/",
    //baseurl: "https://localhost:44341/api/",
    //baseurl3: "https://testreferansapi.tusdata.com/api/",
    //baseurl0: "https://localhost:7288/api/",
    loggedin: false,
    usertype: null,
    username: "",
    userid: null,
    usercatid: null,
    selectedcatid: null,
    userauth: [],
    /** Yetki kodları (a0, a1, a3 vb.). Menü ve ekranda validasyon code üzerinden yapılır. */
    userauthCodes: [],
    userrole: null,
    isScrolled: false,
    scrollY: 0,
    workFolder: "",
    choices: ["A", "B", "C", "D", "E"],
    tustotalq: 200,
    dustotalq: 100,
    tustemelq: 100,
    tusklinikq: 100,
    dustemelq: 40,
    dusklinikq: 80,
    supers: [1, 5, 6, 7]
  },
  mutations: {},
  actions: {
    getDatas: async ({ state, dispatch }, data) => {
      var header = {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8"
      };
      if (data.pos !== "login") {
        let j = await dispatch("authControl");
        if (!j) return;
        else {
          header.Authorization = "Bearer " + j.t;
          header.DType = state.usertype.toString();
        }
      }

      var urlparam = "?";
      if (data.params) {
        Object.keys(data.params).forEach((key, i) => {
          const value =
            data.params[key] != null
              ? encodeURIComponent(data.params[key])
              : "";
          urlparam +=
            key +
            "=" +
            value +
            (i === Object.keys(data.params).length - 1 ? "" : "&");
        });
      }

      // debug log kaldırıldı (menu/auth flow temizliği)

      const res = await axios
        .get(state.baseurl + data.api + urlparam, {
          headers: header
        })
        .then(res => {
          //state.errorapi = false
          return res.data;
        })
        .catch(error => {
          state.errorapi = true;
          if (error && error.response && error.response.status === 401) {
            router.push("/giris");
            return;
          }
        });
      return res;
    },
    postDatas: async ({ dispatch, state }, data) => {
      var opts = {
        headers: {}
      };
      if (data.pos !== "login") {
        var j = await dispatch("authControl");
        if (!j) return;
        else {
          opts.headers.Authorization = "Bearer " + j.t;
        }
      }
      opts.headers.DType = state.usertype.toString();

      let sdata = data.data || {};
      if (data.headers !== undefined) opts.headers = data.headers;
      const res = await axios
        .post(state.baseurl + data.api, sdata, opts)
        .then(res => {
          //state.errorapi = false
          return res.data;
        })
        .catch(error => {
          state.errorapi = true;
          if (error && error.response && error.response.status === 401) {
            router.push("/giris");
            return;
          }
        });
      return res;
    },
    authControl: async ({ state }) => {
      let uc = Cookies.get("tdutype");

      if (uc) {
        let t = JSON.parse(uc);
        state.usertype = t.ut;
        let c = "";
        if (state.usertype === 0) c = Cookies.get("tdataref");
        if (state.usertype === 1) c = Cookies.get("ddataref");
        if (state.usertype === 2) c = Cookies.get("yddataref");
        if (c) {
          let j = JSON.parse(c);
          if (!j.t) {
            if (state.usertype === 0) Cookies.remove("tdataref");
            if (state.usertype === 1) Cookies.remove("ddataref");
            if (state.usertype === 2) Cookies.remove("yddataref");
            router.push("/giris");
          } else {
            const normalizeAuths = aut => {
              let arr = [];
              if (Array.isArray(aut)) arr = aut;
              else if (typeof aut === "string" && aut.trim() !== "") {
                arr = aut
                  .split(",")
                  .map(x => parseInt(String(x).trim()))
                  .filter(n => !isNaN(n));
              }

              // Normalize: numbers only
              arr = (arr || [])
                .map(x => (typeof x === "string" ? parseInt(x) : x))
                .filter(n => typeof n === "number" && !isNaN(n));

              // Backward-compat: eski meta.id (1-8) -> yeni Authorizations.Type (0-10)
              // 1: Hesap Yönetimi (+ Dinamik Özellikler=9)
              // 2: Soru Listesi (+ Soru Arşiv=10)
              // 3: Kategoriler
              // 4: Referans Listesi
              // 5: Ders Notları
              // 6: Ders Notu Ata
              // 7: Loglar + Sınav Yorumları
              // 8: Export
              const looksOld =
                arr.length > 0 && arr.every(n => n >= 1 && n <= 8);
              if (looksOld) {
                const mapped = [];
                arr.forEach(n => {
                  switch (n) {
                    case 1:
                      mapped.push(0, 9);
                      break;
                    case 2:
                      mapped.push(1, 10);
                      break;
                    case 3:
                      mapped.push(2);
                      break;
                    case 4:
                      mapped.push(3);
                      break;
                    case 5:
                      mapped.push(4);
                      break;
                    case 6:
                      mapped.push(5);
                      break;
                    case 7:
                      mapped.push(6, 7);
                      break;
                    case 8:
                      mapped.push(8);
                      break;
                  }
                });
                arr = Array.from(new Set(mapped));
              }

              return arr;
            };

            state.userid = j.uid;
            const normalizedAut = normalizeAuths(j.aut);
            j.aut = normalizedAut;
            state.userauth = normalizedAut;
            state.userauthCodes = Array.isArray(j.authCodes) && j.authCodes.length > 0
              ? j.authCodes
              : (normalizedAut || []).map(t => "a" + t);
            if (!j.authCodes) j.authCodes = state.userauthCodes;
            state.username = j.n;
            state.userrole = j.r;
            state.usercatid = j.cid;

            // Cookie'yi normalize auth listesiyle güncelle (menü/guard boş kalmasın)
            if (state.usertype === 0)
              Cookies.set("tdataref", JSON.stringify(j));
            if (state.usertype === 1)
              Cookies.set("ddataref", JSON.stringify(j));
            if (state.usertype === 2)
              Cookies.set("yddataref", JSON.stringify(j));

            return j;
          }
        } else {
          router.push("/giris");
        }
      } else {
        router.push("/giris");
      }
    },
    putDatas: async ({ dispatch, state }, data) => {
      var opts = {
        headers: {}
      };
      if (data.pos !== "login") {
        var j = await dispatch("authControl");
        if (!j) return;
        else {
          opts.headers.Authorization = "Bearer " + j.t;
        }
      }
      opts.headers.DType = state.usertype.toString();

      let sdata = data.data || {};
      if (data.headers !== undefined) opts.headers = data.headers;
      const res = await axios
        .put(state.baseurl + data.api, sdata, opts)
        .then(res => {
          return res.data;
        })
        .catch(error => {
          state.errorapi = true;
          if (error.response && error.response.status === 401) {
            router.push("/giris");
            return;
          }
        });
      return res;
    },
    deleteDatas: async ({ dispatch, state }, data) => {
      var opts = {
        headers: {}
      };
      if (data.pos !== "login") {
        var j = await dispatch("authControl");
        if (!j) return;
        else {
          opts.headers.Authorization = "Bearer " + j.t;
        }
      }
      opts.headers.DType = state.usertype.toString();

      if (data.headers !== undefined) opts.headers = data.headers;
      const res = await axios
        .delete(state.baseurl + data.api, opts)
        .then(res => {
          return res.data;
        })
        .catch(error => {
          state.errorapi = true;
          if (error.response && error.response.status === 401) {
            router.push("/giris");
            return;
          }
        });
      return res;
    }
  },
  modules: {}
});
